export type SlideType =
  | 'title'
  | 'statement'
  | 'bullets'
  | 'comparison'
  | 'closing'
  | 'calculator'

export interface SlideData {
  id: number
  type: SlideType
  headline?: string
  subtext?: string
  body?: string
  tagline?: string
  mutedLines?: string[]
  bullets?: string[]
  punchline?: string
  highlight?: string
  leftCol?: { header: string; items: string[] }
  rightCol?: { header: string; items: string[] }
  threeWords?: string[]
  finalLine?: string
  showLogo?: boolean
}

export const slides: SlideData[] = [
  {
    id: 1,
    type: 'calculator' as SlideType,
  },
]
